import { GET_LAB_TEST_ORDER } from './constants';
import { ExtraCharges } from './createLabTestCart';
import fetchWithRefresh from './fetchWithRefresh';
import { AdditionalMember } from './orderLabTestCart';

interface Response {
    success: boolean;
    data: Data[];
    error?: string;
}

export interface Data {
    id: string;
    status: string;
    sub_status: string;
    pxid: string;
    pxurl: string;
    docid: string;
    patientid: string;
    vendorid: string;
    vendorname: string;
    vendorOrderId?: string;
    paymode: string;
    vendor_error: string;
    collection_date: string;
    collection_slot: CollectionSlot;
    customerDetails: CustomerDetails;
    created_at: string;
    updated_at: string;
    vendor_order_id: string;
    amount: number;
    paidAmount: number;
    platformdiscount: number;
    pincode: string;
    address: Address;
    cart: Cart[];
    order_id?: string;
    tat_time_str?: string;
    delivered_early_by?: string;
    members: AdditionalMember[];
    inclinic_sample_collection: boolean;
    order_status?: string;
    type?: string;
    edit_order_config: EditOrderConfig;
    extra_charges?: ExtraCharges;
}

export interface CollectionSlot {
    id: number;
    details: Details;
}

export interface Details {
    end_time: string;
    start_time: string;
}

export interface CustomerDetails {
    age: number;
    name: string;
    gender: string;
    mobile: string;
    email?: string;
    customer_email?: string;
    alternative_mobile: string;
}

export interface Address {
    city: string;
    line: string;
    state: string;
    city_id: string;
    pincode: string;
    landmark: string;
    coordinates: string;
    place_id: string;
}

export interface Cart {
    id: string;
    name: string;
    type: string;
    sku_vendor_id: string;
    price: number;
    tests?: Test[];
    testing_type?: string;
}

export interface Test {
    id: string;
    name: string;
}

export type EditOrderConfig = {
    canUpdateSlot: boolean;
    canUpdateTest: boolean;
    canUpdatePaymode: boolean;
    canUpdateDiscount: boolean;
    canUpdateAddress: boolean;
    canUpdatePatientDetails: boolean;
};

export default (pxId: string = '', orderId: string = ''): Promise<Response> => {
    return fetchWithRefresh(GET_LAB_TEST_ORDER(pxId, orderId)).then((res) => res.json());
};
